/* eslint-disable no-return-assign */
import React from "react";
import { Bar } from "react-chartjs-2";
import { Box } from "@mui/material";
import MDTypography from "components/MDTypography";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { numberFormatter } from "utils/HelperFunctions";

function BarChart(props) {
  const { dataStructure } = props;
  const { labels, data, percentages, colors } = dataStructure;

  const options = {
    indexAxis: "y",
    responsive: true,
    maintainAspectRatio: false,
    animation: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: true,
        usePointStyle: true,
        position: "nearest",
        mode: "point",
        intersect: true,
        yPadding: 10,
        xPadding: 10,
        caretSize: 6,
        caretPadding: 10,
        backgroundColor: "white",
        bodyColor: "#000",
        bodyFontColor: "#000",
        borderColor: "#888",
        borderWidth: 1,
        yAlign: "bottom",
        titleColor: "black",
        footerColor: "black",
        callbacks: {
          label: (ctx) =>
            `${ctx.chart.data.labels[ctx.dataIndex]}: ${
              ctx.chart.data.percentages[ctx.dataIndex]
            }%`,
          title: () => "",
        },
      },
      datalabels: {
        color: "#000",
        align: "start",
        anchor: "start",
        font: {
          size: 12,
        },
      },
    },
    layout: {
      padding: {
        left: 35,
        right: 30,
        top: 10,
        bottom: 10,
      },
    },
    scales: {
      y: {
        grid: {
          drawBorder: false,
          display: false,
          drawOnChartArea: false,
          drawTicks: false,
        },
        ticks: {
          display: false,
        },
      },
      x: {
        grid: {
          drawBorder: false,
          display: false,
          drawOnChartArea: false,
          drawTicks: false,
        },
        ticks: {
          display: false,
        },
      },
    },
  };

  const plugins = [
    {
      afterDraw(chart) {
        const { ctx } = chart;
        const { width } = chart;
        const { height } = chart;
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        ctx.font = "12px neuehaas";

        if (chart?.data?.datasets[0].data.length < 1) {
          ctx.fillText("No data to display", width / 2, height / 2);
          ctx.restore();
        }
      },
    },
    ChartDataLabels,
  ];

  return (
    <Box
      sx={{
        pb: "1rem",
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          mb: "-1rem",
        }}
      >
        <MDTypography
          sx={{
            fontSize: "22px",
            fontWeight: "400",
            color: "#444",
          }}
        >
          {data.length ? numberFormatter(data.reduce((a, b) => a + b)) : 0}
        </MDTypography>
        <MDTypography
          sx={{
            fontSize: "12px",
            fontWeight: "400",
            color: "#444",
            position: "relative",
            top: "0.5rem",
            pl: "0.25rem",
          }}
        >
          Total KPIs
        </MDTypography>
      </Box>
      <Box
        sx={{
          flexGrow: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          maxHeight: "90%",
        }}
      >
        <Bar
          data={{
            labels,
            percentages,
            datasets: [
              {
                label: "Completed KPIs",
                data,
                backgroundColor: colors,
                borderColor: "#FFF",
                borderWidth: 1,
                maxBarThickness: 75,
                borderRadius: 3,
                borderSkipped: false,
              },
            ],
          }}
          plugins={plugins}
          options={options}
        />
      </Box>
    </Box>
  );
}

export default BarChart;
